var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33372 6.55557V9.88906C9.33372 10.1838 9.21665 10.4664 9.00827 10.6748C8.79988 10.8832 8.51726 11.0002 8.22256 11.0002H2.11116C1.81646 11.0002 1.53384 10.8832 1.32545 10.6748C1.11707 10.4664 1 10.1838 1 9.88906V3.77767C1 3.48297 1.11707 3.20034 1.32545 2.99196C1.53384 2.78357 1.81646 2.6665 2.11116 2.6665H5.44465",
    stroke: "#2B8FF5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66582 1.00021H10.9993V4.3337",
    stroke: "#2B8FF5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88887 7.11118L11.0003 0.999786",
    stroke: "#2B8FF5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link-blue.b79ebd0cf4871f18e4f36cbd1a737983.svg";
export { ForwardRef as ReactComponent };